import {Switch} from '@mui/material';
import styled from '@emotion/styled';

export const BlueSwitch = styled(Switch)({
  switchBase: {
    color: 'var(--theme-color-blue-light)',
    '& $track': {
      backgroundColor: 'var(--theme-page-line-color)'
    },
    '&$checked': {
      color: 'var(--theme-color-blue)'
    },
    '&$checked + $track': {
      backgroundColor: 'var(--theme-color-blue)'
    }
  },
  checked: {},
  track: {}
});
